// src/utils/imageUrl.js
// ✅ Single source of truth for building fruit image URLs.
// Backend serves images at:  GET /static/uploads/fruits/<filename>
// So full URL is:  http://localhost:5000/static/uploads/fruits/<filename>

// Always use the backend base URL from env — never hardcode localhost in production
const RAW_BASE = process.env.REACT_APP_BACKEND_URL
  || process.env.REACT_APP_API_URL?.replace('/api', '')
  || 'http://localhost:5000';

// Strip trailing slash
const API_BASE = RAW_BASE.replace(/\/$/, '');

/**
 * Given a fruit object, return the full URL of its image.
 * Returns null if no image is available (so Avatar falls back to initials).
 *
 * Handles all the ways the backend might store the path:
 *   fruit.image_url   = 'http://...' (already full URL)
 *   fruit.image_path  = 'abc123_apple.jpg' (just the filename)
 *   fruit.image_path  = '/static/uploads/fruits/abc123_apple.jpg' (path with prefix)
 */
export const getFruitImageUrl = (fruit) => {
  if (!fruit) return null;

  // ── Already a full URL ─────────────────────────────────────
  if (fruit.image_url) {
    // Handle relative paths that came back as image_url
    if (fruit.image_url.startsWith('http')) return fruit.image_url;
    return `${API_BASE}${fruit.image_url}`;
  }

  if (!fruit.image_path) return null;

  const p = fruit.image_path;

  // ── Already a full URL ─────────────────────────────────────
  if (p.startsWith('http://') || p.startsWith('https://')) return p;

  // ── Already has the /static/uploads prefix ─────────────────
  if (p.startsWith('/static/')) return `${API_BASE}${p}`;

  // ── Just the filename — build the full path ────────────────
  return `${API_BASE}/static/uploads/fruits/${p}`;
};